import React , { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

class Typography extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section><a className="anchor"id="typography"></a>
        <h2>Typography</h2>
        <DarkThemeNav anchor="typography" />
        <div className="soft">
          <table className="table table--rows table--notop">
            <thead>
            <tr>
              <th></th>
              <th>Size</th>
              <th>Font Weight</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><h1 className="push--top">Heading 1</h1></td>
              <td className="text--center">27px</td>
              <td className="text--center">Bold</td>
            </tr>
            <tr>
              <td><h2 className="push--top">Heading 2</h2></td>
              <td className="text--center">20px</td>
              <td className="text--center">Bold</td>
            </tr>
            <tr>
              <td><h3 className="push--top">Heading 3</h3></td>
              <td className="text--center">18px</td>
              <td className="text--center">Bold</td>
            </tr>
            <tr>
              <td><h4 className="push--top">Heading 4</h4></td>
              <td className="text--center">16px</td>
              <td className="text--center">Bold</td>
            </tr>
            <tr>
              <td><h5 className="push--top">Heading 5</h5></td>
              <td className="text--center">14px</td>
              <td className="text--center">Bold</td>
            </tr>
            <tr>
              <td><h6 className="push--top">Heading 6</h6></td>
              <td className="text--center">12px</td>
              <td className="text--center">600</td>
            </tr>
            </tbody>
          </table>
        </div>

        <pre><code className="language-html">{`<h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <h4>Heading 4</h4>
          <h5>Heading 5</h5>
          <h6>Heading 6</h6>`}
        </code></pre>

        <br/>
        <div className="callout">Headings use the <a href="https://fonts.google.com/specimen/Poppins?selection.family=Poppins">Poppins font.</a> This is included by adding a link to the head element of your page. See the <a href="getting-started#usage">getting started</a> guide for more details.</div>
        <hr/>

        <h3>Paragraph Styles</h3>

      <div className="soft">
        <p>Nullam quis risus eget <a href="#">urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p>
        <p><small>This line of text is meant to be treated as fine print.</small></p>
        <p>The following snippet of text is <strong>rendered as bold text</strong>.</p>
        <p>The following snippet of text is <em>rendered as italicized text</em>.</p>
        <p>An abbreviation of the word attribute is <abbr title="attribute">attr</abbr>.</p>
      </div>

        <pre><code className="language-html">{`<p>Nullam quis risus eget <a href="#">urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p>
          <p><small>This line of text is meant to be treated as fine print.</small></p>
          <p>The following snippet of text is <strong>rendered as bold text</strong>.</p>
          <p>The following snippet of text is <em>rendered as italicized text</em>.</p>
          <p>An abbreviation of the word attribute is <abbr title="attribute">attr</abbr>.</p>`}</code></pre>
        <br/>
        <hr/>

        <h3>Paragraph Sizes</h3>
        <div className="soft">
          <table className="table table--rows table--notop">
            <thead>
            <tr>
              <th></th>
              <th>Size</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr className="paragraph--large">
              <td>Paragraph body text large</td>
              <td className="text--center">18px</td>
              <td className="text--center">Large</td>
            </tr>
            <tr className="paragraph--medium">
              <td>Paragraph body text Regular</td>
              <td className="text--center">16px</td>
              <td className="text--center">Regular</td>
            </tr>
            <tr className="paragraph--small">
              <td>Paragraph body text small</td>
              <td className="text--center">13px</td>
              <td className="text--center">Small</td>
            </tr>
            <tr className="paragraph--x-small">
              <td>Paragraph body text x-small</td>
              <td className="text--center">10px</td>
              <td className="text--center">Xsmall</td>
            </tr>
            </tbody>
          </table>
        </div>
        <br/>
        <hr/>

        <h3>Links</h3>

        <div className="soft">

          <p>This is a <a href="#">link</a>. You should try and not use phrases like 'click here' for your link text, but rather words that <a href="#">describe the content</a> on the other end for SEO purposes</p>

          <p style={{ backgroundColor: '#454647', color: '#fff' }}>
            This is a <a href="#" className="link--dark-bg">link</a> on a dark background. Add class .link--dark-bg to make link color lighter when placed on dark backgrounds
          </p>
        </div>
          <pre><code className="language-html">{`<p>This is a <a href="#">link</a>.
  You should try and not use phrases like 'click here' for your link text,
  but rather words that <a href="#">describe the content</a> on the other end for SEO purposes</p>`}</code></pre>
          <br/>
          <hr/>

        <h3>Link Sizes</h3>
        <div className="soft">
          <table className="table table--rows table--notop">
            <thead>
            <tr>
              <th></th>
              <th>Size</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr className="paragraph--large">
              <td><a href="#">Text Link large</a></td>
              <td className="text--center">18px</td>
              <td className="text--center">Large</td>
            </tr>
            <tr className="paragraph--medium">
              <td><a href="#">Text Link Regular</a></td>
              <td className="text--center">16px</td>
              <td className="text--center">Regular</td>
            </tr>
            <tr className="paragraph--small">
              <td><a href="#">Text Link Small</a></td>
              <td className="text--center">13px</td>
              <td className="text--center">Small</td>
            </tr>
            <tr className="paragraph--x-small">
              <td><a href="#">Text Link x-small</a></td>
              <td className="text--center">10px</td>
              <td className="text--center">Xsmall</td>
            </tr>
            </tbody>
          </table>
        </div>
        <br/>
        <hr/>

        <h3>Icon Links</h3>
        <div className="soft">
          <p>You can add an icon to a link to give it visual context.</p>
          <a href="#"><i className="fa fa-cog"></i>Settings</a><br/>
          <a href="#"><i className="fa fa-plus-circle"></i>Add Record</a><br/>
          <a href="#">Refresh<i className="fa fa-refresh"></i></a><br/>
        </div>
          <pre><code className="language-html">{`<a href="#"><i class="fa fa-cog"></i>Settings</a>
  <a href="#"><i class="fa fa-plus-circle"></i>Add Record</a>
  <a href="#">Refresh<i class="fa fa-refresh"></i></a>`}</code></pre>
          <br/>
          <hr/>

        <h3>Accessibility Tips</h3>

        <div className="soft">
          <p>Aim to have a logical document structure with a single h1 element with decreasing levels below. The structure can travel up and down as needed, but keep the levels decending in correct order.</p>

          <p>
            h1<br/>
            --h2<br/>
            ----h3<br/>
            ----h3<br/>
            ----h3<br/>
            ------h4<br/>
            --h2<br/>
            --h2<br/>
            --h2<br/>
            ----h3<br/>
            ------h4<br/>
          </p>

          <p>Sometimes you need a certain style/size and wish to use a header 'out of place'. This can be achieved with the helper classes to create the desired styles without breaking accessibility.</p>

        </div>

        <pre><code className="language-html">{`/* Good */
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>

            /* Good - when your h2 looks like the styling of a h3 */
            <h1>Heading 1</h1>
            <h2 class="h3">Heading 2</h2>

            /* Bad- when you try to match the styling of a h2 with a h3 by using the wrong heading level */
            <h1>Heading 1</h1>
            <h3>Heading 2</h3>`}
        </code></pre>
        <br/>
        <hr/>
      </section>
    )
  }
}
export default Typography;



// WEBPACK FOOTER //
// ./styleguide/components/sections/Typography.js